// @flow

import { getQueryFallback } from '../../../../common'

export type State = {
  hasWebsiteChatBeenOpened: boolean,
  isOpen: boolean,
  isOpenInitial: boolean
}

const isOpenInitial = (getQueryFallback('is_open', 'false') === 'true')

export const state: State = {
  hasWebsiteChatBeenOpened: false,
  isOpen: isOpenInitial,
  isOpenInitial: isOpenInitial
}
